<template>
	<li>
		<div class="pack__item">
			<label>
				<input type="radio" name="pack" v-model="$parent.currentItem" :value="item">
				<span class="pack__bord"></span>
				<div class="pack__img">
					<img :src="item.image.path" alt="">
				</div>
				<div class="pack__content">
					<div class="pack__title">{{ item.title }}</div>
					<div class="pack__price" v-if="currentPrice != 0">{{ currentPrice }} ₽</div>
					<div class="pack__props" v-if="item.props">
						<h4>Выберите размер:</h4>
						<select name="" class="uk-select" @click="$parent.check(item)" v-model="currentPrice">
							<option v-for="pr in item.props" :value="pr.price">{{pr.size}}</option>
						</select>
					</div>
				</div>
			</label>
		</div>
	</li>
</template>

<script>
  export default {
    name: "pack-item",
    props: {
      item: '',
      currentId: ''
    },
    data() {
      return {
        currentPrice: ''
      }
    },
    computed: {
      price() {

      },

    },
	  watch: {
      'currentPrice': 'changePrice',
		  'currentId': 'changePrice'
	  },
	  methods:{
      changePrice(){
        this.$emit('changePrice', this.currentPrice);
      },
      setFirstPrice(){
        if(this.item.props){
          if(!this.currentPrice){
            this.currentPrice = this.item.props[0].price;
          } else {
            
          }
        } else {
          this.currentPrice = this.item.price;
        }
        this.changePrice();
      },
      checkProps(){

      }
	  },
	  updated(){
      if(this.currentId == this.item.id){
        this.setFirstPrice();
      }
	  },
	  mounted(){
      this.setFirstPrice();
	  }
  }
</script>


// WEBPACK FOOTER //
// themes/polza/src/js/components/commerce/pack-item.vue